import React, { useEffect, useState, useContext } from 'react';
import { Table, Button, Select, Row, Col, Tooltip, Popconfirm, Dropdown, Menu, Transfer, Card } from 'antd';
import { EditTwoTone, DeleteTwoTone } from '@ant-design/icons';
import {
    getGroups,
    deleteGroup,
    getGroupStudents,
    getStudentsToBindGroup,
    bindStudentToGroup,
    unBindStudentFromGroup
} from '../../../actions';
import { Context } from '../../../defaults';
import { GroupsModal } from './GroupsModal';
import './index.css';

function GroupsTable({ added, setAdded }) {
    const [classes, setClasses] = useState();
    const [groups, setGroups] = useState([]);
    const [teachers, setTeachers] = useState();
    const [selectedInstitution, setSelectedInstitution] = useState();
    const [selectedGroup, setSelectedGroup] = useState();
    const [isStudentChange, setIsStudentChange] = useState(false);
    const [bindedStudents, setBindedStudents] = useState([]);
    const [unBindStudents, setUnBindStudents] = useState([]);

    const { dictionary, language } = useContext(Context);

    const [modalProps, setModalProps] = useState({
        visible: false,
        currentGroup: null,
    });

    const confirm = (id) => {
        deleteGroup(id).then(res => {
            getGroups().then(res => {
                console.log('call 0');
                setGroups(res.data);
            });
        });
        setAdded(!added);
    };


    useEffect(() => {
        getGroups().then(res => {
            console.log('call 1');
            setGroups(res.data);
        });
        setSelectedGroup();
        setBindedStudents();
        setUnBindStudents();
    }, [added]);


    useEffect(() => {
        if (selectedGroup && selectedGroup.id) {
            getGroupStudents(selectedGroup.id).then(res => {
                getStudentsToBindGroup().then(r => {
                    setUnBindStudents([...r.data.filter(m => !res.data.some(x => x.id === m.id)).map(el => el.id)]);
                    setBindedStudents(r.data.map(el => {
                        return {
                            key: el.id,
                            value: el.id,
                            description: `${el.lastName} ${el.firstName} ${el.middleName}`
                        }
                    }));
                });
            });
        }
    }, [selectedGroup]);

    const columns = [
        {
            title: `№`,
            dataIndex: 'id',
            key: 'id',
            width: 50,
        },
        {
            title: `${dictionary?.Name[language]}`,
            dataIndex: 'name',
            key: 'name',
            width: 400,
        },
        {
            title: `${dictionary?.Action[language]}`,
            key: 'action',
            width: 200,
            fixed: 'right',
            render: ({ id }) => (
                <Row gutter={8}>
                    <Col span={6}>
                        <Tooltip placement='top' title={dictionary?.Edit[language]}>
                            <EditTwoTone
                                onClick={() => {
                                    setModalProps({
                                        visible: !modalProps.visible,
                                        currentGroup: groups && groups.find((el) => el.id === id),
                                    });
                                }}
                            />
                        </Tooltip>
                    </Col>
                    <Col span={6}>
                        <Tooltip placement='top' title={dictionary?.Delete[language]}>
                            <Popconfirm
                                placement='bottom'
                                title={dictionary?.AreYouSureToDelete[language]}
                                onConfirm={() => confirm(id)}
                                okText={dictionary?.Yes[language]}
                                cancelText={dictionary?.No[language]}>
                                <DeleteTwoTone key='delete' twoToneColor='#eb2f96' />
                            </Popconfirm>
                        </Tooltip>
                    </Col>
                    <Col span={12}>
                        <Dropdown
                            overlay={
                                <Menu>
                                    <Menu.Item onClick={() => {
                                        const filtered = groups?.find((el) => el.id === id);
                                        if (filtered) {
                                            setSelectedGroup(filtered);
                                        }
                                    }}
                                    >
                                        {dictionary?.ChangeStudentsList[language]}
                                    </Menu.Item>
                                </Menu>
                            }
                            placement='bottomLeft'
                        >
                            <Button>{dictionary?.More[language]}</Button>
                        </Dropdown>

                    </Col>
                </Row>
            ),
        },
    ];


    const closeModal = (saved) => {
        setModalProps({ visible: false });
        if (saved) {
            console.log('call 2');
            getGroups().then(({ data }) => setGroups(data));
        }
    }

    const handleChange = (targetKeys, direction, moveKeys) => {
        if (direction === 'right') {
            unBindStudentFromGroup(moveKeys).then(res => console.log(res));
        }
        else {
            bindStudentToGroup(selectedGroup.id, moveKeys).then(res => console.log(res));
        }
        setUnBindStudents([...targetKeys]);
    };

    const renderItem = item => {
        const customLabel = (
            <span>
                {item.description}
            </span>
        );

        return {
            label: customLabel,
            value: item.value,
        };
    };

    return (
        <React.Fragment>
            <GroupsModal modalProps={modalProps} closeModal={closeModal} />
            {
                <Table style={{ marginTop: 24 }} columns={columns} dataSource={groups} rowKey='id' />
            }
            {
                selectedGroup &&
                <Card title={`${dictionary?.ChangeStudentsList[language]}. ${dictionary.Group[language]} - ${selectedGroup.name}`} style={{ width: '100%' }}>
                    <Transfer
                        dataSource={bindedStudents}
                        titles={[dictionary?.Binded[language], dictionary?.Unbind[language]]}
                        listStyle={{
                            width: 450,
                            height: 400
                        }}
                        targetKeys={unBindStudents}
                        onChange={handleChange}
                        render={renderItem}
                    />
                </Card>
            }
        </React.Fragment>
    );
}

export default GroupsTable;
